import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight:'20px',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',

    }
  },
  cancelBtnRoot: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '80px',
    marginRight: '15px'
  },
  actionBtnRoot: {
    boxShadow: 'none',
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    backgroundColor: '#0e8bb4',
    color: '#FFFFFF',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    padding: '8px 15px',
    minWidth: '80px',
    '&:hover': {
      backgroundColor: '#0e8bb4',
      color: '#FFFFFF'
    }
  },
  actionBtnDisabled: {
    borderColor: 'rgba(0,0,0,0.12)'
  },
  saveButton: {
    marginRight: '15px'
  }
  
}));
